import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks';

export function RoleBasedRoute({ children, allowedRoles, fallbackPath = '/orders' }) {
    const { isAuthenticated, user, isInitialized } = useAuth();

    // Show loading state while initializing
    if (!isInitialized) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (!allowedRoles.includes(user?.role)) {
        return <Navigate to={fallbackPath} replace />;
    }

    return children;
}
